import querystring from 'querystring'
import gtmFSF from 'services/AirBaltic/GTM/FSF'
import RecentSearchMixin from './RecentSearch'
import moment from 'moment'
import Insider from 'services/AirBaltic/Insider'
import Divolte from 'services/AirBaltic/Divolte'
import conf from 'conf'
import { mapState } from 'vuex'

const SearchForm = {
  computed: {
    ...mapState('main', ['selectedCountry', 'selectedLang']),
    getGroupBookingUrl() {
      const tripType = this.$store.state.eHorizonSearchForm.tripType
      const query = querystring.stringify({
        fromCode: this.$store.state.eHorizonSearchForm.origin.value.code,
        fromType: this.$store.state.eHorizonSearchForm.origin.value.type,
        toCode: this.$store.state.eHorizonSearchForm.destin.value.code,
        toType: this.$store.state.eHorizonSearchForm.destin.value.type,
        tripType,
        numberOfAdults: this.$store.state.eHorizonSearchForm.paxSelector.adults,
        numberOfChildren: this.$store.state.eHorizonSearchForm.paxSelector.children,
        numberOfInfants: this.$store.state.eHorizonSearchForm.paxSelector.infants
      })
      let url = this.$store.state.eHorizonSearchForm.groupBookingUrl
      if (
        this.$store.state.device.deviceType !== 'desktop' &&
        this.$store.state.eHorizonSearchForm.groupBookingFormUrl
      ) {
        url = this.$store.state.eHorizonSearchForm.groupBookingFormUrl
      }
      return url + `?${query}`
    }
  },

  mixins: [RecentSearchMixin],
  methods: {
    originClose() {
      this.$store.dispatch('eHorizonSearchForm/origin/closeTypeahead')
    },
    destinClose() {
      this.$store.dispatch('eHorizonSearchForm/destin/closeTypeahead')
    },
    paxSelectorClose() {
      this.closePaxSelector()
    },
    redirectToGroupBooking() {
      window.open(this.getGroupBookingUrl, '_self')
    },

    focusOnInvalidFields() {
      if (this.$store.state.device.deviceType !== 'mobile') {
        if (
          this.$store.getters['eHorizonSearchForm/origin/$v'].$invalid &&
          this.$refs.origin
        ) {
          this.$refs.origin.focus()
          gtmFSF.fsfError('Validation', 'Missing origin')
        } else if (
          this.$store.getters['eHorizonSearchForm/destin/$v'].$invalid &&
          this.$refs.destin
        ) {
          this.$refs.destin.focus()
          gtmFSF.fsfError('Validation', 'Missing destin')
        } else if (
          this.$store.getters['eHorizonSearchForm/promoCodes/$v'].$invalid &&
          this.$refs.promoCode
        ) {
          this.$refs.promoCode.openPromoModalEvent()
          gtmFSF.fsfError('Validation', 'Invalid vouchers')
        }
      }
    },

    saveSearchInRecentSearches() {
      const tripType = this.$store.state.eHorizonSearchForm.tripType === 'return' ? 2 : 1
      const searchObj = {
        fromCode: this.$store.state.eHorizonSearchForm.origin.value.code,
        fromType: this.$store.state.eHorizonSearchForm.origin.value.type,
        toCode: this.$store.state.eHorizonSearchForm.destin.value.code,
        toType: this.$store.state.eHorizonSearchForm.destin.value.type,
        tripType,
        adults: this.$store.state.eHorizonSearchForm.paxSelector.adults,
        children: this.$store.state.eHorizonSearchForm.paxSelector.children,
        infants: this.$store.state.eHorizonSearchForm.paxSelector.infants,
        youngAdults: this.$store.state.eHorizonSearchForm.paxSelector.youngAdults,
        departure: '',
        return: '',
        promoCodes: this.$store.state.eHorizonSearchForm.promoCodes.promoCodes,
        price: ''
      }
      this.addSearchToCookie(searchObj)
    },

    submitForm(isOverlay = false) {
      this.$store.dispatch('eHorizonSearchForm/validateComponents').then(() => {
        if (this.$store.state.eHorizonSearchForm.formValid) {
          this.$store.commit('main/showPlaneLoader', true)
          if (isOverlay) {
            this.setHistoryToFsfOverlay()
            gtmFSF.flightSearchOverlay(
              'flight_search',
              this.$store.state.eHorizonSearchForm
            )
            this.sendInsiderData()
            // this.sendDivolteData()
          } else {
            gtmFSF.flightSearch('flight_search', this.$store.state.eHorizonSearchForm)
          }

          if (this.$store.state.eHorizonSearchForm.paxSelector.groupBooking) {
            this.redirectToGroupBooking()
          } else {
            this.saveSearchInRecentSearches()
            setTimeout(() => {
              this.$refs.searchForm.submit()
            }, 100)
          }

          if (
            this.$store.state.device.deviceType === 'desktop' &&
            this.$store.state.eHorizonSearchForm.calendar.returnDate &&
            !this.isSafari()
          ) {
            const lang = this.selectedLang
            const destination = this.$store.state.eHorizonSearchForm.destin.value.code
            const departureDate =
              this.$store.state.eHorizonSearchForm.calendar.departureDate
            const returnDate = this.$store.state.eHorizonSearchForm.calendar.returnDate

            if (!this.$store.state.main.disableBookingNewTab) {
              const link = `https://www.booking.com/searchresults.html?aid=${conf.bookingAidFSF}&checkin=${departureDate}&checkout=${returnDate}&iata_orr=1&iata=${destination}&label=${conf.bookingLabelFSF}&lang=${lang}`

              setTimeout(() => {
                window.open(link, '_self', 'noopener,noreferrer')
              }, 110)
            }
          }
        } else {
          this.focusOnInvalidFields()
        }
      })
    },

    sendDivolteData() {
      const store = this.$store.state.eHorizonSearchForm

      let data = {
        search: {
          origin: store.origin.value.code,
          destination: store.destin.value.code,
          tripType: store.tripType === 'return' ? 'RT' : 'OW',
          outboundDate: store.calendar.departureDate,
          inboundDate: store.calendar.returnDate,
          adults: store.paxSelector.adults,
          children: store.paxSelector.children,
          infants: store.paxSelector.infants
        }
      }

      Divolte.doDataPush('searchDateSelectionTryme', data)
    },
    isSafari() {
      return window.ApplePaySession ?? false
    },
    async sendInsiderData() {
      if (!Insider.insiderExists()) return

      const store = this.$store.state.eHorizonSearchForm
      let bt_image_url = await this.imgUrlExists(store.destin.value.code)

      let data = {
        title: 'events',
        name: 'btsearch',
        params: {
          search_time: moment().utc().format(),
          search_oac: store.origin.value.code,
          search_dac: store.destin.value.code,
          search_origin_flight_name: store.origin.value.apt,
          search_destination_flight_name: store.destin.value.apt,
          search_departure_date: store.calendar.departureDate
            ? moment(store.calendar.departureDate).utc().format()
            : null,
          search_return_date: store.calendar.returnDate
            ? moment(store.calendar.returnDate).utc().format()
            : null,
          search_noa: store.paxSelector.adults,
          search_noc: store.paxSelector.children,
          search_noi: store.paxSelector.infants,
          search_price: store.selectedFlightPrice.price
            ? store.selectedFlightPrice.price + '·' + store.selectedFlightPrice.decimal
            : null,
          search_trip_type: store.tripType === 'return' ? 'RT' : 'OW',
          saerch_url: this.$_fsfMixin_createDeeplink(true),
          bt_image_url
        }
      }
      Insider.track(data)
    },

    async imgUrlExists(code) {
      let path = `${conf.btTranslationsUrl}hot_deals/insider-destination-images/`
      const genericImg = path + 'generic.jpg'

      if (!code) return genericImg

      let url = path + `${code.toLowerCase()}.jpg`
      try {
        const response = await fetch(url, { method: 'HEAD' })

        if (response.ok) {
          return url
        }
        return genericImg
      } catch (error) {
        return genericImg
      }
    },

    setHistoryToFsfOverlay() {
      const url = new URL(window.location.href)
      url.search = '?opentab=OVL'

      window.history.replaceState(null, null, url)
    },

    submitClpForm() {
      this.$store.dispatch('eHorizonSearchForm/validateComponents').then(() => {
        if (this.$store.state.eHorizonSearchForm.formValid) {
          this.$store.commit('main/showPlaneLoader', true)
          if (this.$store.state.eHorizonSearchForm.paxSelector.groupBooking) {
            this.redirectToGroupBooking()
          } else {
            this.$refs.searchForm.submit()
          }
        } else {
          this.focusOnInvalidFields()
        }
      })
    }
  }
}

export default SearchForm
